import { SiteIdOverrideConfigList } from "stores/wizard/config";
import { siteId1, siteId28 } from "stores/wizard/config/overrideConfigBySiteId/siteIds";

export const overrideConfigBySiteIdList: SiteIdOverrideConfigList = {
  1: siteId1,
  28: siteId28
};
